import React, { ReactNode } from 'react';
import './MetaTable.less';

export interface MetaRow {
  key?: string;
  label: ReactNode;
  value: ReactNode;
}

export interface MetaTableProps {
  rows: MetaRow[];
  className?: string;
}

const MetaTable: React.FC<MetaTableProps> = ({ rows, className = '' }) => (
  <div className={`gt-meta-table ${className}`.trim()}>
    {rows.map((row, index) => (
      <div className="gt-meta-row" key={row.key ?? index}>
        <span className="gt-meta-label">{row.label}</span>
        <span className="gt-meta-divider" />
        <span className="gt-meta-value">{row.value}</span>
      </div>
    ))}
  </div>
);

export default MetaTable;
